import React from "react";
import "../../assets/styles/button.css";

const Button = ({ children, onClick, href, target, rel, className, ...props }) => {
  const isCancel = typeof children === "string" && children.toLowerCase() === "cancel";
  const combinedClassName = `${isCancel ? "CancelButton" : "CommonButton"} ${className || ""}`.trim();

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={combinedClassName}
        onClick={onClick}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={combinedClassName}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;